import { createPortal } from 'react-dom';
import React, { useReducer, type FC } from 'react';
import XIcon from 'assets/img/x-icon.svg?react';
import BaseButton from 'components/atoms/baseButton';
import PersonWorkspaceIcon from 'assets/img/person-workspace.svg?react';
import { useAppDispatch, useAppSelector } from 'store';
import { useTranslation } from 'react-i18next';
import BigSearchIcon from 'assets/img/big-search.svg?react';

import s from './styles.module.scss';
import QueueTable from './table';

interface WorkingQueueProps {}

const WorkingQueue: FC<WorkingQueueProps> = () => {
  const [open, toggle] = useReducer((prev) => !prev, false);
  const workQueue = useAppSelector((state) => state.ccmConsole.workQueue);
  const {
    ccmConsole: { clearQueue },
  } = useAppDispatch();
  const { t } = useTranslation();

  return createPortal(
    <div id="ccm-console-working-queue" className={s.wrapper} data-open={open}>
      <div className={s['trigger-wrapper']} onClick={toggle}>
        <PersonWorkspaceIcon className={s.icon} />
        <p>
          {t('labels.workQueue')} ({workQueue.length ?? 0}){' '}
        </p>
      </div>
      <div className={s.header}>
        <h2 className={s.title}>{t('labels.workingQueue')}</h2>
        <BaseButton
          label={t('labels.clearQueue')}
          type="secondary"
          className={s['clear-queue-btn']}
          icon={<XIcon />}
          disabled={workQueue.length === 0}
          onClick={clearQueue}
          dataCy="clear-queue-btn"
        />
      </div>
      <div className={s.body} id="p0p0p0">
        {workQueue.length === 0 ? (
          <div className={s.empty}>
            <BigSearchIcon className={s['empty-icon']} />
            <p>{t('messages.emptyWorkingQueueMEssage')}</p>
          </div>
        ) : (
          <QueueTable />
        )}
      </div>
    </div>,
    document.getElementById('root')!,
  );
};
export default WorkingQueue;
